import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
export var VALUES_PROP_TYPE = PropTypes.arrayOf(PropTypes.shape({
  value: PropTypes.string.isRequired,
  display: EBPropTypes.translation.isRequired
}));
export var PLACEHOLDER_DUMMY_VALUE = '';